//node_modules
import { useRouter } from "next/router";
import urlJoin from "proper-url-join";

const WEBSITE_DOMAIN = "https://www.adjusttothegoodlifetravel.com/";

function useCanonical(queries: string[] = []) {
  const router = useRouter();
  const url = new URL(urlJoin(router.asPath, { trailingSlash: true }), WEBSITE_DOMAIN);
  for (const [param, _] of Array.from(url.searchParams.entries())) {
    if (!queries.includes(param)) {
      url.searchParams.delete(param);
    }
  }
  return url.href;
}

export default useCanonical;
